

<nb-card accent=danger>
    <nb-card-header>
       Are you sure you want to delete {{name}}?
    </nb-card-header>
    <nb-card-body>
        <button nbButton outline (click)="no()">No</button>
        <button nbButton status="danger" (click)="yes()">Yes</button>

    </nb-card-body>
</nb-card>
